import { render, staticRenderFns } from "./schedule-dialog.vue?vue&type=template&id=65af92d0&scoped=true"
import script from "./schedule-dialog.vue?vue&type=script&lang=js"
export * from "./schedule-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af92d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65af92d0')) {
      api.createRecord('65af92d0', component.options)
    } else {
      api.reload('65af92d0', component.options)
    }
    module.hot.accept("./schedule-dialog.vue?vue&type=template&id=65af92d0&scoped=true", function () {
      api.rerender('65af92d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/chat/schedule-message/schedule-dialog.vue"
export default component.exports